/*
  Add here your own custom javascript codes
*/
document.addEventListener("DOMContentLoaded", function () {
  const navbar = document.getElementById("navbar-desktop");
  const dropdownLink = $(".dropdown");

  dropdownLink.on("mouseover", function () {
    navbar.classList.add("navbar-colored");
  });

  dropdownLink.on("mouseout", function () {
    navbar.classList.remove("navbar-colored");
  });
});

$(function () {
  $('p,img,h1,h2,h3,a').attr('data-aos', 'fade-up');
  if (window.location.pathname === '/pages/faq' || window.location.pathname === '/pages/privacy-policy' ||  window.location.pathname === '/pages/shipping-returns') {
    $('.description p,img,h1,h2,h3,a').attr('data-aos', '');
  }
  $('.fabric-swatches p,img,h1,h2,h3,a').attr('data-aos', '');
  $('.nav-item p,a').attr('data-aos', '');
  $('p,img,h1,h2,h3,a').attr('data-aos-duration', '1000');
  $('.product-card img, .product-card-link, .site-credits, #offcanvas-menu a').removeAttr('data-aos');
  $('.product-card img, .product-card-link, .product-title,.site-credits, #offcanvas-menu a').removeAttr('data-aos-duration');
  $('#footer-desktop a, #footer-desktop img').attr('data-aos', 'fade-in');
  AOS.init();
  $('.product-card-title').attr('data-aos-duration', '1000');
  if ($(window).width() < 767) {
    $('.row-category img,.row-category a').removeAttr('data-aos');
    $('.row-category img,.row-category a').removeAttr('data-aos-duration');
    const productImages = $(".product-media-gallery img");
    if (productImages && productImages.length > 1) {
      $(".d-lg-none .product-media-gallery").slick({
        dots: true,
        arrows: false,
        infinite: false,
      });
    }

    const sliderNavItem = $('.product-media-gallery .slick-dots li'),
    slidesLength = $('.slick-slider img').length;

    sliderNavItem.css('width', 'calc(100% / '+ slidesLength +')');
  }
});
